<template>
  <div class="row">
    <div class="col-4">
      <p class="light text-right" ml-5>Custom text on coupon</p>
    </div>
    <div class="col-8">
      <input
        type="text"
        maxlength="40"
        @change="update"
        class="form-control"
        name="ecoupon_custom_text"
        v-model="reward.ecoupon_custom_text"
        :disabled="disabled || reward.reward_type !== 'ecoupon'"
      />
    </div>
  </div>
</template>

<script>
import rewardMixins from "../reward.mixins";

const message = `Update Custom text on coupon Reward`;

export default {
  mixins: [rewardMixins],

  data() {
    return {
      message: {
        error: `${message} #${this.reward.id} error.`,
        success: `${message} #${this.reward.id} success.`,
      },
    };
  },
};
</script>
